export default "__VITE_ASSET__BL$GBebi__"